import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-filter-impounded-leads',
  templateUrl: './filter-impounded-leads.component.html',
  styleUrls: ['./filter-impounded-leads.component.scss']
})
export class FilterImpoundedLeadsComponent {
  
  public form = { queue: null, company: null, broker: null };
  public temperature: string;
  public queueOptions = [{ id: 1, name: 'Produtos da região central de São Paulo' }];
  public companyOptions = [{ id: 2, name: 'Lopes SP' }];
  public brokerOptions = [{ id: 3, name: 'Aline Diretoria' }];
  @Output() closeModal: EventEmitter<boolean> = new EventEmitter<boolean>();

  handleClose(): void {
    this.closeModal.emit(false);
  }

  handleSelect(event): void {
  }
}
